export default "__VITE_ASSET__BR2gTj$i__"